import { Router, Utils } from "@lightningjs/sdk";
import { Navbar } from "core.components";
import { DependencyToken } from "./Container";
import { container } from "./DefaultContainer";
import { EventType } from "./EventBus";
import { routes } from "./Router";
export class App extends Router.App {
    static _template() {
        return Object.assign(Object.assign({ h: 1080, w: 1920, color: 0xff0d001e, rect: true, clipbox: true }, super._template()), { Widgets: {
                Navbar: { type: Navbar },
            } });
    }
    static getFonts() {
        return [
            {
                family: "Insatiable Display",
                url: Utils.asset("fonts/InsatiableDisplay-BoldCondensed.woff2"),
                descriptors: { weight: "700" },
            },
            {
                family: "Lato",
                url: Utils.asset("fonts/Lato-Regular.ttf"),
                descriptors: { weight: "400" },
            },
            {
                family: "Lato",
                url: Utils.asset("fonts/Lato-Bold.ttf"),
                descriptors: { weight: "700" },
            },
            {
                family: "Roboto",
                url: Utils.asset("fonts/Roboto-Regular.ttf"),
                descriptors: { weight: "400" },
            },
            {
                family: "Roboto",
                url: Utils.asset("fonts/Roboto-Bold.ttf"),
                descriptors: { weight: "700" },
            },
            {
                family: "Roboto Condensed",
                url: Utils.asset("fonts/Roboto-Condensed-Regular.ttf"),
                descriptors: { weight: "400" },
            },
            {
                family: "Roboto",
                url: Utils.asset("fonts/Roboto-Medium.ttf"),
                descriptors: { weight: "500" },
            },
            {
                family: "Staff Wide",
                url: Utils.asset("fonts/StaffWideTest-Bold.ttf"),
                descriptors: { weight: "700" },
            },
            {
                family: "BW Stretch",
                url: Utils.asset("fonts/BwStretchDEMO-Regular.otf"),
                descriptors: { weight: "500" },
            },
        ];
    }
    $setVideoVisible(visible) {
        this.rect = !visible;
    }
    _init() {
        super._init();
        container.get({ token: DependencyToken.EventProducer })({
            event: {
                data: {
                    app: this,
                    lngHook: "init",
                },
                type: EventType.StartUp,
            },
        });
        setInterval(() => {
            this.stage.gc();
        }, 5000);
    }
    _handleAppClose() {
        // When the router’s history is empty, the SDK will continue to handle
        // the back key and try to close the app. Since we hanlde the closing
        // of the app internally then we just return true so app doesnt lose focus.
        return true;
    }
    _handleBackRelease() {
        Router.back();
    }
    _setup() {
        super._setup();
        Router.startRouter(routes, this);
        container.get({ token: DependencyToken.EventProducer })({
            event: {
                data: {
                    app: this,
                    lngHook: "setup",
                },
                type: EventType.StartUp,
            },
        });
        // Router automatically reassigns `_handleBack` so let's stop it and do our
        // own thing in `_handleBackRelease`.
        this._handleBack = () => { };
    }
}
export default App;
//# sourceMappingURL=App.js.map